var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21033",
    "data-name": "Grupo 21033",
    transform: "translate(-914 -403)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_264",
    "data-name": "Elipse 264",
    cx: 46,
    cy: 46,
    r: 46,
    transform: "translate(914 403)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19900",
    "data-name": "Grupo 19900",
    transform: "translate(801.582 191.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_227",
    "data-name": "Elipse 227",
    transform: "translate(123.418 222.418)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27050",
    "data-name": "Trazado 27050",
    d: "M-1674.881-2717.434l7.969,7.969,18.357-18.357",
    transform: "translate(1819.848 2976.19)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.c62175305a59f74c463af373617ddd5b.svg";
export { ForwardRef as ReactComponent };